import type { GeneratedDoorPlacement } from "building-types/doors/doorTypes";
import type { WallCut } from "building-types/walls/wallCutTypes";
import type { GeneratedWindowPlacement } from "building-types/windows/windowTypes";

export function openingShouldUseExteriorCasing(
  fullOpening: GeneratedDoorPlacement | GeneratedWindowPlacement | WallCut,
): boolean {
  const { opening, type } = fullOpening;
  if (!opening) {
    return false;
  }

  if (type === "WALL_CUT") {
    return false;
  }

  const { hasWrapping = false } = opening;
  // any active wrapping modes override the usage of casing
  // clipping profiles
  if (hasWrapping) {
    return false;
  }

  return opening.casingClipsFinish;
}
